import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import Badge from './Badge';
import LinkButton from './LinkButton';
import { translateCategoryName } from '../../constants/shoppingI18n';
import { getCurrentBeLang } from '../../contexts/LanguageContext';

/* 프라이빗 쇼핑 서비스 display section - used inside Card across:
   ReservationDetail, TransferComplete, TransferPayment, BookingSettings
   items: [{ brand, name, price (formatted string), qty, image_url? }]
   total: complete formatted string already including currency (예: "139,000원" / "US$7" / "139,000 원")
          — 통화 단위는 호출자가 useMoney 등으로 직접 포함해 전달. 이 컴포넌트는 단위 추가 X.
   showTitle: h3 제목 표시 여부 (default true)
   onEdit: 수정 버튼 콜백 (제공 시 "수정" LinkButton 표시)
   BugHerd #88: image_url 이 있으면 placeholder 대신 실제 이미지 표시.
   BugHerd #88 follow-up: brand 가 BE category code(oliveyoung/daiso/mart/other) raw 값으로
   넘어오는 케이스 → translateCategoryName 으로 현재 언어 라벨 치환. */
export default function ShoppingSection({ items = [], total, showTitle = true, onEdit }) {
  const { t } = useTranslation();
  const beLang = getCurrentBeLang();
  return (
    <>
      {showTitle && (
        <h3 className="text-lg font-bold text-mono-900">{t('common.private_shopping_section')}</h3>
      )}

      <div className="bg-mono-50 rounded-lg p-2.5 flex flex-col gap-2.5">
        <div className="flex items-center justify-between">
          <span className="text-sm font-bold text-mono-900">{t('common.selected_items')}</span>
          {onEdit && <LinkButton size="xs" onClick={onEdit}>{t('common.edit')}</LinkButton>}
        </div>
        <div className="flex flex-col gap-1">
          {items.map((item, i) => (
            <div key={i} className="flex gap-2.5 bg-white rounded-lg p-2.5">
              <div className="w-20 h-20 bg-mono-100 rounded-lg flex items-center justify-center shrink-0 overflow-hidden relative">
                {item.image_url ? (
                  <img src={item.image_url} alt={item.name || ''} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                ) : (
                  <Icon name="image" size={24} className="text-mono-400 opacity-40" />
                )}
              </div>
              <div className="flex-1 flex flex-col justify-between">
                <Badge variant="shopping" className="self-start">{translateCategoryName(item.brand, beLang)}</Badge>
                <span className="text-sm font-bold text-mono-900">{item.name}</span>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-normal text-mono-900">{item.price}</span>
                  <span className="inline-flex items-center justify-center min-w-[41px] h-[37px] px-4 border border-mono-300 rounded-full text-sm font-normal text-mono-900">
                    {item.qty}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {total != null && (
        <p className="text-lg font-bold text-mono-900">{total}</p>
      )}
    </>
  );
}
